export default {
  title: 'Betal med {{method}}',
  hint: 'Tryk på knappen nedenfor, og godkend betalingen i vinduet fra {{method}}.',
  confirming: 'Bekræfter din betaling…',
  cancel: 'Annuller betaling',
  unavailable: 'Denne betalingsmetode er ikke tilgængelig lige nu. Vælg en anden.',
  approval_timeout:
    'Vi hørte ikke fra {{method}}. Hvis vinduet ikke åbnede, så tjek, at pop-ups er tilladt, og prøv igen eller vælg en anden betalingsmetode.',
};
